/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  teamIdentifier: ZodTypes.Team.Identifier,
  urlEncodedGroupName: z.string().min(1),
});

export const DeleteTeamGroup = {
  id: 'team-group.delete',
  tag: 'Team',
  summary: 'Remove team group',
  description: 'Remove an OIDC group from an organization team',
  method: 'delete',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/team/${params.teamIdentifier}/group/${params.urlEncodedGroupName}`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: { 'application/json': { schema: z.string().optional() } },
    },
  },
} as const satisfies Endpoint;
